import React, { FC, useMemo, useRef, useState } from 'react';

import { Button } from 'devextreme-react/button';
import DataGrid, { Column, FilterRow, Lookup, Pager, Paging } from 'devextreme-react/data-grid';

import ClaimsProvider from 'components/claimsBlock';

import { AppCard, AppLayoutTop } from '../../../../components/appComponents';
import $createStore from '../../../../utils/create-store-instance';
import { CashItemAddEditModal, CashItemDeleteModal } from './components';

const CashList: FC = () => {
  //const unitData: any = $createStore('/v1/unit', 'id');]

  const [modalIsVisible, setModalIsVisible] = useState(false);
  const [modalIsVisibleDelete, setModalIsVisibleDelete] = useState(false);
  const [cashFlowId, setCashFlowId] = useState<number | null>(null);

  const requestDateSource = useMemo(() => {
    return $createStore('/v1/CashFlowItem', 'id');
  }, []);

  const requestCashFlowItemTypes = useMemo(() => {
    return $createStore('/v1/CashFlowItem/types', 'id');
  }, []);

  const refGrid = useRef<DataGrid | null>(null);

  const refresh = () => refGrid.current?.instance.refresh();

  return (
    <div className="container-dev">
      {modalIsVisible && (
        <CashItemAddEditModal
          changeVisible={setModalIsVisible}
          visible={modalIsVisible}
          refresh={refresh}
          id={cashFlowId}
        />
      )}
      {modalIsVisibleDelete && (
        <CashItemDeleteModal
          changeVisible={setModalIsVisibleDelete}
          visible={modalIsVisibleDelete}
          refresh={refresh}
          id={cashFlowId}
        />
      )}

      <AppLayoutTop title="Статьи движения ДС">
        <ClaimsProvider claimsBlock={['CanCreateCashFlowItem']}>
          <Button width={120} text="Создать" type="default" onClick={() => setModalIsVisible(true)} />
        </ClaimsProvider>
      </AppLayoutTop>

      <AppCard>
        <DataGrid
          dataSource={requestDateSource as any}
          showBorders={false}
          loadPanel={{
            enabled: true,
            text: 'Загрузка',
          }}
          ref={refGrid}
          remoteOperations={true}
        >
          <FilterRow visible={true} />

          <Column dataField="name" caption="Имя" />
          <Column dataField="cashFlowType" caption="Тип">
            <Lookup dataSource={requestCashFlowItemTypes} valueExpr="id" displayExpr="name" />
          </Column>
          <Column dataField="isCalculationProvider" caption="Расчет с поставщиками" />
          <Column
            dataField="actions"
            caption=""
            width={120}
            cellRender={(data) => (
              <>
                <ClaimsProvider claimsBlock={['CanEditCashFlowItem']}>
                  <Button
                    icon="edit"
                    type="default"
                    stylingMode="text"
                    onClick={() => {
                      setCashFlowId(data.data.id);
                      setModalIsVisible(true);
                    }}
                  />
                </ClaimsProvider>
                <ClaimsProvider claimsBlock={['CanDeleteCashFlowItem']}>
                  <Button
                    icon="trash"
                    type="default"
                    stylingMode="text"
                    onClick={() => {
                      setCashFlowId(data.data.id);
                      setModalIsVisibleDelete(true);
                    }}
                  />
                </ClaimsProvider>
              </>
            )}
          />

          <Paging defaultPageSize={15} />
          <Pager showPageSizeSelector={true} allowedPageSizes={[15, 30, 50, 100]} />
        </DataGrid>
      </AppCard>
    </div>
  );
};

export default CashList;
